// 审批类型
export enum EAuditType {
    /// <summary>
    /// 项目下发审批
    /// </summary>
    ProjectIssue = 10,

    /// <summary>
    /// 项目变更审批
    /// </summary>
    ProjectChange = 11,

    /// <summary>
    /// 项目回执审批
    /// </summary>
    ProjectReceipt = 20,

    /// <summary>
    /// 项目回执接收
    /// </summary>
    ProjectReceiptReceive = 21,

    /// <summary>
    /// 项目回执审批
    /// </summary>
    MeetingProjectReceipt = 30,

    /// <summary>
    /// 项目回执接收
    /// </summary>
    MeetingProjectReceiptReceive = 31,

    /// <summary>
    /// 项目回执审批
    /// </summary>
    OAProjectReceipt = 40,

    /// <summary>
    /// 项目回执接收
    /// </summary>
    OAProjectReceiptReceive = 41,

    /// <summary>
    /// 过程调度审批
    /// </summary>
    ProcessSchedule = 50,

    /// <summary>
    /// 过程调度接收
    /// </summary>
    ProcessScheduleReceive = 51,

    /// <summary>
    /// 沟通
    /// </summary>
    FlowChat = 60,
}
